<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rJnlNU/images/9781250119452.jpg?1718183453150" alt="This image is the cover for the book Mockingbird"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mockingbird
      </h1>
      <p class="bookDescription body article font2">
        <b>“This biography will not disappoint those who loved the novel and the feisty, independent, fiercely loyal Scout, in whom Harper Lee put so much of herself.” —Garrison Keillor, <i>The New York Times Book Review</i></b><br/><br/>An extensively revised and updated edition of the <i>New York Times</i>–bestselling biography of Harper Lee, reframed from the perspective of the recent publication of Lee’s Go Set a Watchman.<br/><br/><i>To Kill a Mockingbird</i>—the twentieth century’s most widely read American novel—has sold thirty million copies and still sells a million yearly. In this in-depth biography, first published in 2006, Charles J. Shields brings to life the woman who gave us two of American literature’s most unforgettable characters, Atticus Finch and his daughter, Scout.<br/><br/>Years after its initial publication—with revisions throughout the book and a new epilogue—Shields finishes the story of Harper Lee’s life, up to its end. There’s her former agent getting her to transfer the copyright for <i>To Kill a Mockingbird</i> to him, the death of Lee’s dear sister Alice, a fuller portrait of Lee’s editor, Tay Hohoff, and—most vitally—the release of Lee’s long-buried first novel and the ensuing public devouring of what has truly become the book of the year, if not the decade: <i>Go Set a Watchman</i>.<br/><br/>“To every <i>To Kill a Mockingbird</i> reader, I send this message: The story isn’t over. There’s so much more to come, and you’ll find it all in Charles Shields’ delightful and insightful <i>Mockingbird</i>.” —Homer Hickam, #1 <i>New York Times</i>–bestselling author<br/><br/>“Lively, absorbing . . . If you treasure Scout, one of literature’s more endearing characters, you’ll like the woman who emerges in <i>Mockingbird</i>.” —<i>The Miami Herald</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles J. Shields
      </h2>
      
      <p class="authorDescription body article"><B>Charles J. Shields</B> is the author of <I>And So It Goes: Kurt Vonnegut, A Life </I>(Holt 2011), a <I>New York Times</I> and <I>Washington Post</I> Notable Nonfiction Book. Also, <I>Mockingbird: A Portrait of Harper Lee</I> (Holt 2006), an acclaimed, bestselling biography, recently revised as <I>Mockingbird: A Portrait of Harper Lee from Scout to Go Set a Watchman</I> (Holt 2016). <I>I Am Scout: The Biography of Harper Lee </I>(Henry Holt Books for Young Readers 2008) is for young adults. He is also the author of nonfiction books for young people. He and his wife reside in Charlottesville, Virginia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eca8a234